import message from "../components/chat_msg_view.vue";
import chatmsg_search from "../components/chatmsg_search";
import chat_tag_channels from "../components/chat_tag_channels";
import chat_tag_relevant from "../components/chat_tag_relevant";
import chat_tag_cities from "../components/chat_tag_cities";
import chatgrp_details from "../components/chatgrp_details";
import microapp_search from "../components/microapp_search";
import media_utility from "./media_utility";
import notification_dialog from "../components/notification_dialog";
import notification_utility from "./notification_utility";
import board_utility from "./board_utility";
import video_utility from "./video_utility";
import cache from "./cache_ls";

export default {
  name: 'chatmsg',
  components:{
    chatgrp_details,
    message,
    chat_tag_channels,
    chat_tag_relevant,
    chat_tag_cities,
    chatmsg_search,
    microapp_search,
    notification_dialog
  },
  props:["gNewMessageFromFirebaseListener"],
  data () {
    return {
      socket:this.$store.getters.getSocket,
      loading: false,
      grp:{group_name: ""},
      msg_search: '',
      show_search_bar: false,
      search_loader: false,
      participant_is_admin: false,
      currentItem: null,
      reload_messages: 0,
      tab_items_style_obj:{},
      grp_board_id:'',
      dep_type: process.env.VUE_APP_ENV,
      share_url: "",
      share_email_body: '',
      notification_dialog:false,
      group_icon_data:{},
      show_notification_menu: true,
      attrs:null,
      on:null
    }
  },
  updated() {
  },
  created() {
  },
  async mounted() {
    this.get_group_details();
    this.get_board_for_selected_group();

    //For board navigation (This is done to navigate back to the group from a board.)
    this.$store.commit("setBoardBackButton", "/chat_message");

    this.group_icon_data =  await this.getChatgrpIconList;

    if(this.group_icon_data == null){
      this.group_icon_data = {};
    }    
  },
  beforeDestroy() {
    this.$store.commit('setScrollToPinnedmsg', null);
    this.scroll_first_time_on = false;
  },
  computed: {
    isOnGide() {
      return this.$store.getters.getIsOnGide
    },
    userData() {
      return this.$store.getters.userData;
    },
    async selectedGroup() {
      return await this.$store.getters.selectedGroup;
    },
    selectedDeeplinkMessage() {
      return this.$store.getters.selectedDeeplinkMessage;
    },
    relevantMessage() {
      return this.$store.getters.relevantMessage;
    },
    async getChatgrpList(){
      return await this.$store.getters.getChatgrpList;
    },
    getSnackBar(){
      return this.$store.getters.getSnackBar;
    },
    getClientDeviceHeight(){
      return this.$store.getters.getClientDeviceHeight;
    },
    getListenerChatgrpEditResponse(){
      return this.$store.getters.getListenerChatgrpEditResponse;
    },
    getListenerGroupDeleteResponse(){
      return this.$store.getters.getListenerGroupDeleteResponse;
    },
    getListenerUserEditResponse(){
      return this.$store.getters.getListenerUserEditResponse;
    },
    getListenerGroupActionResponse(){
      return this.$store.getters.getListenerGroupActionResponse;
    },
    async getChatgrpIconList(){
      return await this.$store.getters.getChatgrpIconList;
    },
  },
  methods: {
    /**
     * get_group_details
     */
    async get_group_details() {
      let selectedGroupId = await this.selectedGroup;
      let grp_details = await cache.get_from_device_storage("get_group_details", this.userData.user_id + "_" + "chatgrp_list", "FS")

      if(grp_details) {
        for(let index in grp_details) {
          if(grp_details[index]){
            //Get data for the currently selected Group
            if(grp_details[index]['group_id'] && (grp_details[index]['group_id'] == selectedGroupId)) {
              this.grp = grp_details[index];
              this.participant_is_admin = (this.grp.role == 1) ? true : false;
              break;
            }
          }
        }
      }
    },
    /**
     * go_back
     * go back to previous page with relevant msg set to null
     */
    go_back() {
      this.$store.commit("setRelevantMessage", null);
      //Keep the route else, Deeplink on Android and IOS will not be able to goback to the home/chat page
      this.$router.push('/chat'); 
      
      //this.$router.back(-1); //Dont Use this
    },
    /*
     * go_to_profile
     * 
     */
    go_to_profile(){
      if(this.grp.type == 0){
        let participant_id = "";
        if(this.grp.participants && this.grp.participants != null){
          let participant_ids = this.grp.participants.split(',');
          participant_id = participant_ids.find((participant_id)=>{
            return participant_id !== this.userData.user_id; 
          });
        }
        
        this.$store.commit('setParticipantId', participant_id);
        this.$router.push('/participant-profile');
      }
      else{
        this.$router.push('/chatgrp_details');
      }
    },
    /*
     * grp_details
     * Get group details if any change from chat msg view component
     */
    grp_details(grp){
      this.grp = grp;
    },
    /*
     * close_search
     *
     */
    close_search() {
      this.msg_search = '';
      this.show_search_bar = false;
    },
    /*
     * search_keyword
     *
     */
    search_keyword(keyword) {
      this.msg_search = keyword;
    },
    /*
     * mention_message_open
     *
     */
    mention_message_open(){ 
      let selectedTag ={
        type:4,
        name:this.userData.user_id
      }
      this.$store.commit('setSelectedTag', selectedTag);
      this.$router.push('/mention_message_user');
    },
    /*
    * get_board_for_selected_group
    * 
    */
    async get_board_for_selected_group() {
      let selected_board_type = "Group";
      let response = await board_utility.board_list(this, selected_board_type, await this.selectedGroup);
      if (response.resp_status) {
        this.grp_board_id = response.resp_data.data[0]['board_id'];
      }
      else{
        this.grp_board_id = '';
      }
    },
    /*
    * go_to_board
    * 
    */
    go_to_board() {
      if(this.grp_board_id) {
        this.$store.commit('setSelectedBoard', this.grp_board_id);
        this.$router.push("/boards/"+this.grp_board_id);
      }
      else {
        //"create_board" passed in id to open create board popup on boards page. This is a Hack
        this.$router.push("/boards/create_board");
      }
    },
    /**
    * setGroupForMedia
    */
    async setGroupForMedia(){
      this.$store.commit('setSelectedGroupForMedia', await this.selectedGroup);
      this.$router.push('/media');
    },
    /**
     * goToRoute
     */
     goToRoute () {
      if(!this.isElementVisible()){
        return
      }

      if (this.grp.type == 0) {
        let participantId = this.grp.participants.split(",").find(e => e != this.userData.user_id)
        this.$store.commit("setParticipantId", participantId)
        return "/participant-profile"
      }
      return "/chatgrp_details"
     },
    /*
    * checkStrFirstCharHasAlphabet
    * */
    checkStrFirstCharHasAlphabet(str){
      if(/^[A-Za-z]/.test(str)) {
        return true;
      }
      return false;
    },
    /**
     * cloudvoice_start_call
     * Launch a video call with cloudvoice
     */
    cloudvoice_start_call(){      
      video_utility.cloudvoice_start_call(this, this.userData.user_id, this.participant_is_admin, this.grp.group_id, this.grp.group_name);
    },
    /**
     * invite_dialog_share
     */    
    async invite_dialog_share(){
      //Build the Share Body for email
      this.share_url = process.env.VUE_APP_GROUP_LINK_SHARE_URL + await this.selectedGroup;      
      this.share_email_body = `Visit ${process.env.VUE_APP_INSTALL_URL} to install the GIDE App. After installing, click this link to join the group ${this.data.group_name} on GIDE.AI\r\n\r\n" + this.share_url + "\r\n\r\n${process.env.VUE_APP_GROUP_LINK_SHARE_TITLE}`;
      
      /*
      //for android in app browser
      if(window.androidBridge){
        this.share_url = ""; //Don't Send the URL as it is causing duplicate
        window.androidBridge.inviteLink(this.share_url, this.share_email_body);
      }
      else
      */
      { 
        const shareData = {
          title: 'GIDE.AI',
          text: this.share_email_body,
        }
        
        //If testing on PC/Laptop Browser by simulating the UA, then rename android/iphone to "Desktop"
        //console.log(navigator.userAgent);
        if(navigator.userAgent.toLowerCase().indexOf("android") > -1){
          //android normal browser
          try {
            navigator.share(shareData);
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }
        }
        else if(navigator.userAgent.toLowerCase().indexOf("iphone") > -1 || navigator.userAgent.toLowerCase().indexOf("ipad") > -1){
          //IOS normal browser
          try {
            navigator.share(shareData);
          } 
          catch(err) {
            this.snackbar = true;
            this.err_msg = JSON.stringify(err);
          }
        }
        else{
          //all normal browser normal popup
          this.dialog = true;
        }
      }
    },
    /*
    * get_group_icon
    * */
    get_group_icon(group, group_icon_data){
      return media_utility.get_group_icon(group, group_icon_data);
    },
     /* 
     * notification_setting
     * 
     */
    notification_setting() {
      if (window.androidBridge) {
        notification_utility.notification_dialog_android(this, this.grp.group_id, this.grp.group_name);
      }
      else {
        this.notification_dialog = true;
      }
    },
    /**
    * isElementVisible
    * Returns a boolean value, that determines whether a certain element is to be displayed on mesh
    * Used to hide certain elements from the UI in case, mesh is opened in an iframe on GIDE Maketing website
    */
   isElementVisible() {
    const frame = cache.get_frame()
    if (frame != "GIDE") {
      // Mesh is opened on some other parent app e.g. GIDE Marketing website so the element will not be visible
      return false
    }
    else {
      // element is on GIDE
      return true
    }
   }
  },
  watch: {
    /**
     * selectedGroup
     */
    selectedGroup: function () { 
      this.get_group_details();
      this.get_board_for_selected_group();
    },
    /**
     * currentItem
     */
    currentItem: function () {
      if(this.currentItem == 0) {
        this.reload_messages += 1;
        this.$store.commit('setSelectedTag', null);
      }
    }
  }
}
